import React, { memo } from "react";
import { Link } from "react-router-dom";

import { convertTimestampToFormat, truncateText } from "../../../../utils";
import { theme } from "../../../../theme";

const TableRow = ({ item, documentType, onOpenFiles, onOpenChat }) => {
    const {
        doc_id,
        doc_type,
        doc_comment,
        doc_days_left,
        doc_expiry_date,
        doc_is_have_new_document,
        doc_ftm,
        doc_skill
    } = item;

    const isExpiring = doc_days_left > 0;

    return (
        <li className="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg">
            {/* ---------------- Left Content ---------------- */}
            <div className="d-flex flex-column">
                <h6
                    className={`text-sm text-uppercase font-weight-bolder mb-1 hover-${theme.main} cursor-pointer`}
                    onClick={() => onOpenFiles(item, doc_id)}
                >
                    {doc_type}
                    {doc_is_have_new_document && (
                        <i className="material-icons ms-2">flag</i>
                    )}
                </h6>

                <span className="mb-3 text-xs">
                    {doc_comment ? truncateText(doc_comment, 100) : "N/A"}
                </span>

                {doc_ftm && (
                    <Link
                        to={`/ftm/view/${doc_ftm.ftm_id}`}
                        className={`mb-2 d-flex align-items-center text-dark hover-${theme.main}`}
                    >
                        <img
                            src={doc_ftm.ftm_profile_image_path}
                            className="avatar avatar-xs mb-1"
                            alt="ftm_profile"
                        />
                        <span className="nav-link-text ms-2 ps-1 font-weight-bold text-sm">
                            {doc_ftm.ftm_forename} {doc_ftm.ftm_surname}
                        </span>
                    </Link>
                )}

                {documentType !== "personal" && doc_skill && (
                    <span className="mb-2 text-xs">
                        Service categories:
                        <span className="text-dark ms-sm-2 font-weight-bold">
                            {doc_skill.skill?.skill_name} - {doc_skill.sub_skill_name}
                        </span>
                    </span>
                )}

                <span className="mb-2 text-xs">
                    Expiry date:
                    <span className="text-dark ms-sm-2 font-weight-bold">
                        {convertTimestampToFormat(doc_expiry_date)}
                    </span>
                </span>

                <span className="text-xs">
                    Days until expiry:
                    <span
                        className={`ms-sm-2 font-weight-bold text-${isExpiring ? "warning" : "danger"
                            }`}
                    >
                        {Math.abs(doc_days_left)}{" "}
                        {isExpiring ? "EXPIRING SOON" : "EXPIRED DAYS"}
                    </span>
                </span>
            </div>

            {/* ---------------- Actions ---------------- */}
            <div className="ms-auto text-end">
                <button
                    className={`btn btn-link text-${theme.main} text-gradient px-1 mb-0`}
                    type="button"
                >
                    <i className="material-icons me-2" style={{ fontSize: 25 }}>
                        call
                    </i>
                </button>

                <button
                    className={`btn btn-link text-${theme.main} text-gradient px-1 mb-0`}
                    type="button"
                    onClick={() => onOpenChat(doc_ftm)}
                >
                    <i className="material-icons me-2" style={{ fontSize: 25 }}>
                        chat_bubble
                    </i>
                </button>
            </div>
        </li>
    );
};

/* Prevent re-render unless item reference changes */
export default memo(TableRow);